import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Wrapper = styled.div`
  position: relative;
  display: inline-flex;
`;

export const TriggerButton = styled.button`
  all: unset;
  box-sizing: border-box;

  width: 32px;
  height: 32px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 10rem;
  border: 1px solid ${theme.colors.gray.Cinza_10};
  cursor: ${props => props.disabled ? "default" : "pointer"};

  &:hover {
    background-color: ${props => props.disabled ? "transparent" : theme.colors.gray.Cinza_12};
  }

  svg {
    display: block;
  }
`;

// Posicionado via style inline (position: fixed + top/left calculados) por
// quem renderiza - ele é portalado pra document.body pra não ficar preso
// no overflow/scroll horizontal da linha da tabela onde normalmente mora.
export const Menu = styled.div`
  /* A navbar lateral fixa usa z-index até 10001 - precisa ficar acima dela. */
  z-index: 20000;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  padding: 8px;

  border-radius: 12px;
  background-color: ${theme.colors.white.Branco};
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.16);
`;

export const Divider = styled.div`
  height: 1px;
  margin: 6px 4px;
  background-color: ${theme.colors.gray.Cinza_12};
`;

export const MenuItem = styled.button`
  all: unset;
  box-sizing: border-box;
  width: 100%;

  display: flex;
  align-items: center;
  gap: 10px;

  padding: 9px 8px;
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background-color: ${props => props.danger
        ? `${theme.colors.red.Vermelho_erro}14`
        : props.success
            ? `${theme.colors.green.Verde_AgroReceita}14`
            : theme.colors.gray.Cinza_13};
  }
`;

export const MenuItemIcon = styled.span`
  width: 18px;
  height: 18px;
  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  color: ${props => props.danger
    ? theme.colors.red.Vermelho_erro
    : props.success
        ? theme.colors.green.Verde_AgroReceita
        : theme.colors.gray.Cinza_2};

  img, svg {
    width: 100%;
    height: 100%;
  }
`;

export const MenuItemText = styled.span`
  font-family: Lato;
  font-size: 13px;
  font-weight: 700;
  color: ${props => props.danger
    ? theme.colors.red.Vermelho_erro
    : props.success
        ? theme.colors.green.Verde_AgroReceita
        : theme.colors.gray.Cinza_2};
`;
